import { Button } from "@mui/material"

interface IntroduceSectionCloseButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
}

const IntroduceSectionCloseButton = ({
  onClick,
}: IntroduceSectionCloseButtonProps) => {
  return (
    <Button
      variant="text"
      onClick={e => {
        e.preventDefault()
        onClick && onClick(e)
      }}
      sx={{
        minWidth: "unset",
        width: "auto",
        position: "absolute",
        top: "24px",
        right: "24px",
        zIndex: 9999,
      }}
    >
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12.5" cy="12.5" r="12.5" fill="#E75F2B" />
        <path
          d="M7.50001 17.4996L17.4969 7.50269"
          stroke="white"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.50001 7.49965L17.4969 17.4966"
          stroke="white"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  )
}

export default IntroduceSectionCloseButton
